import { render, staticRenderFns } from "./depense_list.vue?vue&type=template&id=0baf0aa6&"
import script from "./depense_list.vue?vue&type=script&lang=js&"
export * from "./depense_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports